module.exports = __webpack_public_path__ + "img/bg_avatar_female_80.65170417.png";